import React, { useState, useEffect, Fragment } from 'react';
import { TextField, Box, Button, CircularProgress, Typography, Card, CardActions, CardContent, CardHeader, DateTime } from '@mui/material';

import { useNotify } from 'react-admin'
import client from '../common/client';
import Help from '../component/Help'

const ProjectVersionField = props => {
    const notify = useNotify();
    const [loading, setLoading] = React.useState(false);
    const [version, setVersion] = React.useState('none');
    const [versionRegDate, setVersionRegDate] = React.useState(null);
    const [newVersion, setNewVersion] = React.useState('0.0.1');

    const distributeNow = (e) => {
        setLoading(true)
        client.request_get(`/api/project/distribute/current/${props.project.id}`).then(res => {
            setLoading(false)
            if (res.r) {
                notify(`Distrubute Success, It takes 30~60sec`);
                setVersion(res.version)
                setNewVersion(res.new_version)
                setVersionRegDate(res.version_reg_date)
            } else {
                notify(`${res.msg}`);
            }
        }).catch(e => {
            setLoading(false)
            notify(`${e}`);
        })
    }

    const distributeUp = (e) => {
        setLoading(true)
        client.request_get(`/api/project/distribute/up/${props.project.id}`).then(res => {
            setLoading(false)
            if (res.r) {
                notify(`Distrubute Success, It takes 30~60sec`);
                setVersion(res.version)
                setNewVersion(res.new_version)
                setVersionRegDate(res.version_reg_date)
            } else {
                notify(`${res.msg}`);
            }
        }).catch(e => {
            setLoading(false)
            notify(`${e}`);
        })
    }

    useEffect(() => {
        setVersion(props.project.version)
        setVersionRegDate(props.project.version_reg_date)
        setNewVersion(props.project.new_version)
    }, [props.project])
    return (
        <Card >
            <CardHeader
                title="S3 Online Distrubution"
                action={
                    <Help />
                }
            />
            <CardContent>
                <Box>
                    Current version : {version}
                </Box>
                {versionRegDate && <Box>
                    {new Date(Date.parse(versionRegDate)).toLocaleDateString()}
                    {new Date(Date.parse(versionRegDate)).toLocaleTimeString()}
                </Box>}
            </CardContent>
            <CardActions>
                <Box m={1}>
                    {version != 'none' && <Button variant="contained" color="secondary" startIcon={loading && <CircularProgress size={24} />} onClick={distributeNow} disabled={loading}>
                        Distribute Override</Button>}
                </Box>
                <Box m={1}>
                    <Button variant="contained" color="primary" startIcon={loading && <CircularProgress size={24} />} onClick={distributeUp} disabled={loading}>Distribute version up {newVersion}</Button>
                    {/* <Button variant="outlined">Rollback</Button> */}
                </Box>
            </CardActions>
        </Card>
    );
};

export default ProjectVersionField;
